export const STATUS_META = {
  active: { label: 'Ativa', dot: '#16a34a', bg: 'rgba(22,163,74,0.12)', color: '#166534' },
  trialing: { label: '7 dias grátis', dot: '#f59e0b', bg: 'rgba(245,158,11,0.16)', color: '#92400e' },
  past_due: { label: 'Pagamento pendente', dot: '#f97316', bg: 'rgba(249,115,22,0.16)', color: '#9a3412' },
  canceled: { label: 'Cancelada', dot: '#ef4444', bg: 'rgba(239,68,68,0.16)', color: '#991b1b' },
  unpaid: { label: 'Inadimplente', dot: '#ef4444', bg: 'rgba(239,68,68,0.16)', color: '#991b1b' },
  incomplete: { label: 'Pendente', dot: '#f97316', bg: 'rgba(249,115,22,0.16)', color: '#9a3412' },
  incomplete_expired: { label: 'Expirada', dot: '#94a3b8', bg: 'rgba(148,163,184,0.2)', color: '#475569' },
  exempt: { label: 'Ativa', dot: '#22c55e', bg: 'rgba(34,197,94,0.16)', color: '#166534' },
  inactive: { label: 'Inativa', dot: '#94a3b8', bg: 'rgba(148,163,184,0.2)', color: '#475569' },
};

export const INVOICE_STATUS = {
  paid: { label: 'Pago', bg: 'rgba(34,197,94,0.16)', color: '#166534' },
  open: { label: 'Em aberto', bg: 'rgba(59,130,246,0.16)', color: '#1d4ed8' },
  uncollectible: { label: 'Inadimplente', bg: 'rgba(239,68,68,0.16)', color: '#991b1b' },
  void: { label: 'Cancelado', bg: 'rgba(148,163,184,0.2)', color: '#475569' },
  draft: { label: 'Rascunho', bg: 'rgba(148,163,184,0.2)', color: '#475569' },
};

export const PAGE_BG = `
  radial-gradient(ellipse at 0% 0%, rgba(8, 145, 178, 0.08), transparent 45%),
  radial-gradient(ellipse at 100% 0%, rgba(124, 58, 237, 0.06), transparent 45%),
  radial-gradient(ellipse at 50% 100%, rgba(255, 199, 90, 0.04), transparent 50%),
  linear-gradient(180deg, #f7f9ff 0%, #ffffff 60%, #f7f9ff 100%)
`;

export const CARD_SX = {
  borderRadius: '20px',
  border: '1px solid rgba(15, 23, 42, 0.06)',
  boxShadow:
    '0 14px 36px -14px rgba(15, 23, 42, 0.10), 0 0 0 1px rgba(15, 23, 42, 0.02)',
  background: '#ffffff',
  overflow: 'hidden',
  transition: 'box-shadow 0.3s ease, transform 0.3s ease',
};

export const SECTION_ICON_BOX_SX = {
  width: 40,
  height: 40,
  borderRadius: '12px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background:
    'linear-gradient(135deg, rgba(8, 145, 178, 0.14) 0%, rgba(124, 58, 237, 0.10) 100%)',
  color: '#0891b2',
  flexShrink: 0,
  border: '1px solid rgba(8, 145, 178, 0.18)',
};

export const PRIMARY_BUTTON_SX = {
  borderRadius: '12px',
  textTransform: 'none',
  fontWeight: 700,
  fontSize: '0.9rem',
  px: 2.5,
  py: 1,
  background: 'linear-gradient(135deg, #0891b2 0%, #0e7490 100%)',
  boxShadow: '0 10px 24px -8px rgba(8, 145, 178, 0.45)',
  color: '#ffffff',
  transition:
    'transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease',
  '&:hover': {
    background: 'linear-gradient(135deg, #0e7490 0%, #155e75 100%)',
    boxShadow: '0 14px 32px -8px rgba(8, 145, 178, 0.6)',
    transform: 'translateY(-1px)',
  },
  '&.Mui-disabled': {
    background: '#e2e8f0',
    color: '#94a3b8',
    boxShadow: 'none',
  },
};

export const SUITE_PRODUCTS = [
  { key: 'atendabot', name: 'AtendaBot', tagline: 'Atendimento com IA no WhatsApp 24/7', link: '/atendabot' },
  { key: 'reservo', name: 'Reservo', tagline: 'Sistema de reservas para seu restaurante', link: '/reservo' },
  { key: 'feedback_hero', name: 'Feedback Hero', tagline: 'Coleta automática de avaliações', link: '/feedback-hero' },
  { key: 'cardapio', name: 'One Menu', tagline: 'Cardápio digital com QR Code', link: '/cardapio' },
  { key: 'cv', name: 'CurrículoCerto', tagline: 'Recrutamento e seleção para food service', link: '/cv' },
  { key: 'clube_mesa', name: 'Clube de Mesa', tagline: 'Programa de fidelidade gamificado', link: '/clube', comingSoon: true },
  { key: 'checklist', name: 'ChefList', tagline: 'Checklists operacionais digitais', link: '/checklist', comingSoon: true },
];

export const BILLING_PRODUCT_KEY_TO_UI_PRODUCT_KEY = {
  curriculo_certo: 'cv',
  one_menu: 'cardapio',
};

export const UI_PRODUCT_KEY_TO_BILLING_PRODUCT_KEY = {
  cardapio: 'one_menu',
  cv: 'curriculo_certo',
};

export const formatDate = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(date);
};

export const formatCurrency = (amount, currency) => {
  if (amount === null || amount === undefined) return '-';
  const normalizedCurrency = String(currency || 'BRL').toUpperCase();
  const value = Number(amount) / 100;
  if (!Number.isFinite(value)) return '-';
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: normalizedCurrency,
    minimumFractionDigits: 2,
  }).format(value);
};

export const getBillingProductKeyForUiProductKey = (productKey) =>
  UI_PRODUCT_KEY_TO_BILLING_PRODUCT_KEY[productKey] || productKey;

export const getUiProductKeyForBillingProductKey = (productKey) =>
  BILLING_PRODUCT_KEY_TO_UI_PRODUCT_KEY[productKey] || productKey;

export const formatPaymentMethod = (invoice) => {
  const paymentType = String(invoice?.payment_method_type || '').trim().toLowerCase();
  const brand = String(invoice?.card_brand || '').trim();
  const last4 = String(invoice?.card_last4 || '').trim();

  if (last4) {
    const brandLabel = brand
      ? brand.charAt(0).toUpperCase() + brand.slice(1)
      : 'Cartão';
    return `${brandLabel} •••• ${last4}`;
  }

  if (paymentType === 'card') return 'Cartão';
  if (paymentType === 'boleto') return 'Boleto';
  if (paymentType === 'pix') return 'Pix';
  if (paymentType) return paymentType.replace(/_/g, ' ');
  return '-';
};
